<template>
  <div class="flex items-center justify-center lg:justify-start relative w-full">
    <NuxtLink
      class="absolute left-0 lg:hidden"
      to="/knowledge"
    >
      <CommonSVGTemplate
        :path="arrowLeft"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      />
    </NuxtLink>
    <div class="text-center">
      <h1 class="heading-2 lg:heading-1">
        {{ title || 'KNOWLEDGE BASE' }}
      </h1>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});

const arrowLeft = `
  <path d="M9.57 5.92993L3.5 11.9999L9.57 18.0699" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20.4999 12H3.66992" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
`;
</script>
